import { CellRenderers, createValueFormatter, getBooleanColDef } from '@cmg/data-grid';
import type { DotStatusProps } from '@cmg/design-system';

import type { InvestorFirmFragment } from '../graphql/__generated__';

export enum LinkedStatus {
  Linked = 'Linked',
  NotLinked = 'Not Linked',
}

export const getStatusColor = (_, data: InvestorFirmFragment): DotStatusProps['color'] => {
  return data.isLinked ? 'success' : 'disabled';
};

export const valueFormatter = createValueFormatter<InvestorFirmFragment, boolean>({
  gridRow: ({ value }) => {
    return value ? LinkedStatus.Linked : LinkedStatus.NotLinked;
  },
});

export const linkedStatusColDef = getBooleanColDef<InvestorFirmFragment, boolean>({
  field: 'isLinked',
  headerName: 'Linked Status',
  cellRenderer: CellRenderers.DotStatusCellRenderer,
  cellRendererParams: { getStatusColor, value: 'show-dot-status' },
  valueFormatter,
  filterParams: {
    values: [true, false],
    valueFormatter,
  },
});
